export type PortalPaymentKind = 'punch_card' | 'card' | 'mobilepay' | 'invoice' | 'other';
export type PortalPaymentStatus = 'pending' | 'paid' | 'failed' | 'processing' | 'refunded';

const CARD_PAYMENT_METHODS = new Set(['card', 'clinio_pay', 'stripe']);
const MOBILEPAY_METHODS = new Set(['mobilepay']);
const INVOICE_METHODS = new Set(['invoice']);

export function isPreferredInvoicePaymentMethod(method: string | null | undefined): boolean {
  const value = (method ?? '').toLowerCase();
  return CARD_PAYMENT_METHODS.has(value) || MOBILEPAY_METHODS.has(value);
}

export function resolvePortalPaymentKind(input: {
  payment_method: string | null;
  payment_status: PortalPaymentStatus | null;
  visit_status: string | null;
  invoice_payment_method: string | null;
  has_paid_invoice: boolean;
}): PortalPaymentKind | null {
  const aptMethod = (input.payment_method ?? '').trim().toLowerCase();
  const invoiceMethod = (input.invoice_payment_method ?? '').trim().toLowerCase();

  if (aptMethod === 'punch_card') return 'punch_card';
  if (MOBILEPAY_METHODS.has(aptMethod) || MOBILEPAY_METHODS.has(invoiceMethod)) {
    return 'mobilepay';
  }
  if (CARD_PAYMENT_METHODS.has(aptMethod) || CARD_PAYMENT_METHODS.has(invoiceMethod)) {
    return 'card';
  }
  if (INVOICE_METHODS.has(aptMethod) || INVOICE_METHODS.has(invoiceMethod) || input.has_paid_invoice) {
    return 'invoice';
  }
  if (aptMethod === 'manual' || input.visit_status === 'payment_completed') {
    return 'other';
  }
  if (input.payment_status === 'paid') return 'other';
  return null;
}

export function isPortalAppointmentPaid(input: {
  payment_status: PortalPaymentStatus | null;
  payment_kind: PortalPaymentKind | null;
}): boolean {
  return input.payment_status === 'paid' || input.payment_kind != null;
}

export function portalPaymentStatusKey(input: {
  payment_status: PortalPaymentStatus | null;
  payment_kind: PortalPaymentKind | null;
}): 'paid' | 'unpaid' | 'failed' | 'processing' | 'refunded' {
  if (isPortalAppointmentPaid(input)) return 'paid';
  switch (input.payment_status) {
    case 'failed':
      return 'failed';
    case 'processing':
      return 'processing';
    case 'refunded':
      return 'refunded';
    case 'paid':
    case 'pending':
    case null:
      return 'unpaid';
    default: {
      const _exhaustive: never = input.payment_status;
      return _exhaustive;
    }
  }
}
